import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { useCallback } from 'react';
import { situations, matrimonialRegimes, activitySectors } from 'utils/formData';
import { texts } from 'utils/languages/fr';
import {
    MemoizedActivitySectorsSelect,
    MemoizedMatrimonialRegimeSelect,
    MemoizedSituationsSelect,
    MemoizedTextField,
} from '../memoized-components/MemoizedComponents';

const useStyles = makeStyles(theme => ({
    field: { width: '100%', maxWidth: theme.constants.tunnelInputWidth },
}));

const SituationFormFPCIPP = ({ situation, onChange, errors, tunnelErrors }) => {
    const classes = useStyles();

    const handleChange = useCallback(
        e => {
            const name = e.target.name;
            const value = e.target.value;
            onChange(name, value);
        },
        [onChange]
    );

    if (!situation) {
        return null;
    }

    return (
        <React.Fragment>
            <Typography variant="h6" gutterBottom>
                {texts.SITUATION_PERSONNELLE}
            </Typography>

            <MemoizedSituationsSelect
                name="situation"
                inputStyle={classes.field}
                onChange={handleChange}
                selected={situations[2].name}
                value={situation.situation}
                error={errors.situation}
            />

            {situation.situation === situations[0].name && (
                <MemoizedMatrimonialRegimeSelect
                    name="matrimonialRegime"
                    label={texts.REGIME_MATRIMONIAL}
                    inputStyle={classes.field}
                    onChange={handleChange}
                    selected={matrimonialRegimes[0].name}
                    value={situation.matrimonialRegime}
                    error={errors.matrimonialRegime}
                />
            )}

            <MemoizedTextField
                name="noOfPersons"
                type="number"
                inputStyle={classes.field}
                onChange={handleChange}
                label={texts.NOMBRE_DE_PERSONNES_A_CHARGE}
                value={situation.noOfPersons}
                showError={!tunnelErrors.numberOfDependents && !errors.noOfPersons}
                error={errors.noOfPersons || tunnelErrors.numberOfDependents}
            />

            <MemoizedTextField
                name="profession"
                inputStyle={classes.field}
                onChange={handleChange}
                label={texts.PROFESSION}
                value={situation.profession}
                showError={!tunnelErrors.jobTitle}
                error={errors.profession || tunnelErrors.jobTitle}
            />

            <MemoizedActivitySectorsSelect
                label={texts.ACTIVITY_SECTOR}
                name="activitySector"
                inputStyle={classes.field}
                value={situation.activitySector}
                onChange={handleChange}
                error={errors.activitySector}
                selected={activitySectors[0].name}
            />
        </React.Fragment>
    );
};

export default SituationFormFPCIPP;
